import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { catchError, from, lastValueFrom, map, Observable, of, take } from 'rxjs';
import { environment } from 'src/environments/environment';
import { StorageUtil } from 'src/utils/storage.util';


class CustomTranslateLoader implements TranslateLoader {
    constructor(private http: HttpClient) {}
    private _isObject(item) {
        return (item && typeof item === 'object' && !Array.isArray(item));
    }
    private _mergeDeep(target, ...sources) {
        if (!sources.length) return target;
        const source = sources.shift();

        if (this._isObject(target) && this._isObject(source)) {
            for (const key in source) {
                if (this._isObject(source[key])) {
                    if (!target[key]) Object.assign(target, { [key]: {} });
                    this._mergeDeep(target[key], source[key]);
                } else {
                    Object.assign(target, { [key]: source[key] });
                }
            }
        }

        return this._mergeDeep(target, ...sources);
    }
    getTranslation(lang: string): Observable<any> {
        return this.http.get('/dist/assets/translations/vo.json').pipe(map(local => {
            let fullTranslations = this._mergeDeep({}, local);
            StorageUtil.set('translationMap', fullTranslations);
            return fullTranslations;
        }))
    }
}
class TranslateLocalLoader implements TranslateLoader {
    constructor(private http: HttpClient) {}
    private _removeNestedNullUndefined(_translations: { [key: string]: any }) {
        let translations = structuredClone(_translations);
        for (const key in translations) {
            if (translations[key] === null || translations[key] === undefined || translations[key] === 'BEMÆRK! OVERSÆTTELSEN ER IKKE I BRUG') {
                delete translations[key];
            } else if (typeof translations[key] === 'object') {
                translations[key] = this._removeNestedNullUndefined(translations[key]);
            }
        }
        return translations;
    }
    private _isObject(item) {
        return (item && typeof item === 'object' && !Array.isArray(item));
    }
    private _mergeDeep(target, ...sources) {
        if (!sources.length) return target;
        const source = sources.shift();

        if (this._isObject(target) && this._isObject(source)) {
            for (const key in source) {
                if (this._isObject(source[key])) {
                    if (!target[key]) Object.assign(target, { [key]: {} });
                    this._mergeDeep(target[key], source[key]);
                } else {
                    Object.assign(target, { [key]: source[key] });
                }
            }
        }

        return this._mergeDeep(target, ...sources);
    }
    private _spreadAsObject(arg0: { [key: string]: string; }): { [key: string]: any; } {
        let newObj = {}
        Object
            .entries(arg0)
            .forEach(([key, value]) => {
                if(value === 'BEMÆRK! OVERSÆTTELSEN ER IKKE I BRUG')
                    return;
                let objPos = newObj;
                key
                    .split('.')
                    .forEach((subkey, i, arr) => {
                        if (objPos[subkey] == null && i < arr.length - 1) {
                            objPos[subkey] = {}
                        } else if (i == arr.length - 1 && typeof objPos == 'object' && value != null) {
                            objPos[subkey] = value;
                        }
                        objPos = objPos[subkey];
                    })
            })
        return newObj;
    }
    getTranslation(lang: string): Observable<any> {
        return from(new Promise(async (resolve, reject) => {
            let _default = await lastValueFrom(this.http.get('/dist/assets/translations/vo.json').pipe(take(1), catchError(() => (of({})))));
            let translations = this._removeNestedNullUndefined(this._spreadAsObject(StorageUtil.get<{ [key: string]: string }>('translations')));
            let fullTranslations = this._mergeDeep({}, _default, translations);
            StorageUtil.set('translationMap', fullTranslations);
            resolve(fullTranslations);
        }))
    }

}
export class CustomMissingTranslationHandler {
    handle(params: any) {
        if (!environment.production) {
            console.warn('Missing Translation for:', params.key);
        }
        return '';
    }
}
export function TranslationHttpLoader(http: HttpClient) {
    let loader: TranslateLoader;

    if (!environment.production) {
        loader = new CustomTranslateLoader(http);
    } else {
        loader = new TranslateLocalLoader(http);
    }
    return loader;
}
